const CommonData = [
  {
    enablement: [
      {
        id: "1",
        name: "Self Introduction",
        karma: "20",
        description:
          "You know yourself the best, yet presenting a good self may allow others to get to know you. Posting an introduction to yourself  is an important first step in connecting with the community. Please use your real name and add a profile picture before you post the Introduction. You might include a brief description of yourself, your profiles, skills, and so on.",
        example:
          "Post  your intro in #self-introduction channel with a hashtag #ge-self-intro",
      },
      {
        id: "2",
        name: "Introduction to Discord",
        karma: "50",
        description:
          "Are you brand new to Discord? Not to fear, we've got you covered. This course will walk you through the fundamentals to advanced features of discord.",
        link: "https://mulearn.atfg.gtechindia.org/page/introduction-to-discord",
        inner_description:
          "After course completion, share the certificate in #task-dropbox channel with hashtag #ge-intro-to-discord",
        example:
          "#ge-intro-to-discord Hi! I've completed the Intro to Discord course. Here’s my certificate",
      },
    ],
  },
];

export default CommonData;
